import { EnumUtils } from '../../../utils/enum.utils';

export enum PackageActionContext {
  Create = 'create',
  Edit = 'edit',
}

export namespace PackageActionContext {
  export function getAllContexts(): PackageActionContext[] {
    return EnumUtils.GetValues<PackageActionContext>(PackageActionContext);
  }

  export function isValid(context: null | string): boolean {
    if (context === null) {
      return false;
    }

    return getAllContexts().includes(context as PackageActionContext);
  }
}
